<template>
	<div>
		<div class="row">
            <div class="col-xs-0 col-sm-2 col-lg-4"></div>
            <div class="col-xs-12 col-sm-10 col-lg-8">
                <div class="row ">
                    <div class="col-lg col-sm col-xs-12 mb-2" v-for="(buttonName,index ) in buttonArray">
                        <input type="button" class="btn  float-right"  :class="{ 'btn-outline-primary' : period != index + 1 , 'btn-primary' : period == index + 1}"  style="width:100%" @click="search(index + 1)" :value="buttonName">
                    </div>

                </div>
            </div>
        </div>
  

        <div class="row mt-4">
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats border border-secondary" style="background-color:#80D6FF">
                    <div class="stats-info">
                        <p v-if="!apiReady">Loading....</p>
                        <p v-else>{{stats.count ? numberWithCommas(stats.count) : 0}}</p>
                        <h4>TOTAL QR REGISTERED</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats border border-secondary" style="background-color:#FBA2A8">
                    <div class="stats-info">
                        <p v-if="!apiReady">Loading....</p>
                        <p v-else>{{stats.total_active ? numberWithCommas(stats.total_active) : 0}}</p>
                        <h4>TOTAL ACTIVE QR</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats border border-secondary" style="background-color:#6FD9D1">
                    <div class="stats-info">
                        <p v-if="!apiReady">Loading....</p>
                        <p v-else>{{stats.total_replaced ? numberWithCommas(stats.total_replaced) : 0}}</p>
                        <h4>TOTAL REPLACED QR</h4>
                    </div>
                </div>
            </div>
			
        </div>

        <totalQRRegisteredByVehicleType style="margin-left:10px" class="mt-4" :data="totalVehicleRegisteredByType" :isUpdate="isUpdate"></totalQRRegisteredByVehicleType>
	</div>
</template>

<script>
    import totalQRRegisteredByVehicleType from './charts/totalQRRegisteredByVehicleType'
    import * as am4core from "@amcharts/amcharts4/core";

    export default {
        components : {
            totalQRRegisteredByVehicleType
        },
        data(){
            return {
                stats : {
                    total : 0,
                    total_morning : 0,
                    total_night : 0
                },
                apiReady : false,
                period : 1,
                buttonArray : ['Month To Date' , 'Last Month' , 'Year To Date' , 'Last Year' , 'All Time'],
                totalVehicleRegisteredByType : {},
                isUpdate : 0
            }
        },
        mounted(){
            this.search(this.period);
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
        },
        methods : {
            numberWithCommas(x) {
                return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            search(period){
                this.period = period;
                
                let apiUrl = '/api/dashboard/h2?period=' + this.period;

                this.$http.get(apiUrl)
                .then((resp)=>{
                    var data = resp.data.data;

                    this.stats = data.highlight[0];
                    this.totalVehicleRegisteredByType = data.totalVehicleRegisteredByType
                    this.apiReady = true;
                    this.isUpdate++;
                })
                .catch((err)=>{
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped>
    .stats-info p{
        color:#fff !important;
    }

    .stats-info h4{
        color: #fff !important;
        font-weight: bold;
    }
</style>